const enableEmojiReactions = () => {
  return Fraction.Helpers.isLabEnabled("emoji-reactions");
};

module.exports = {
  metadata: () => {
    return {
      id: "emoji-reactions",
      name: i18n.t("emoji-reactions.title"),
      description: i18n.t("emoji-reactions.description"),
      toggle: enableEmojiReactions,
      starLab: false,
      lab: "student",
      type: "extension"
    };
  }
};
